import type { GridItemPosition } from './gridLayoutModels';

export function positiveOrZeroPosition(position: GridItemPosition): GridItemPosition {
  return {
    top: position.top > 0 ? position.top : 0,
    left: position.left > 0 ? position.left : 0,
  };
}
